// Pure decision for the mobile "detail level" — a collection is opened, or a track/route detail is
// open (collection OR Library). Drives the Instagram-style chrome on mobile: the bottom tab bar
// hides, the floating top-left back button shows, and the bottom sheets reclaim the tab bar's
// height. The bare overview / Map tab / Library list are NOT detail levels.
//
// Kept side-effect free (no stores/refs) so the truth table is unit-testable; the reactive
// `isMobileDetailLevel` computed in WorkspaceMapContainer feeds it live store values.
export interface MobileNavLevelInput {
  /** Mobile viewport — the tab bar + sheets only exist here. */
  isSmallScreen: boolean
  /** Immersive "Full map" mode owns its own chrome. */
  isImmersive: boolean
  isLanding: boolean
  isTrackDrawing: boolean
  isTrackEdit: boolean
  isNavigating: boolean
  /** A track/route detail sheet is open (collection or Library). */
  isRouteSheetOpen: boolean
  /** A `:workspaceId` route param exists (a collection is opened). */
  hasWorkspaceId: boolean
  /** Returning to / showing the collections overview. */
  isInOverview: boolean
}

export function isMobileDetailLevel(input: MobileNavLevelInput): boolean {
  if (hasBlockingMobileChromeState(input)) return false
  return input.isRouteSheetOpen
}

export function isMobileCollectionChromeVisible(input: MobileNavLevelInput): boolean {
  if (hasBlockingMobileChromeState(input)) return false
  return input.isRouteSheetOpen || (input.hasWorkspaceId && !input.isInOverview)
}

function hasBlockingMobileChromeState(input: MobileNavLevelInput): boolean {
  if (
    !input.isSmallScreen ||
    input.isImmersive ||
    input.isLanding ||
    input.isTrackDrawing ||
    input.isTrackEdit ||
    input.isNavigating
  ) {
    return true
  }
  return false
}
